import MARKDOWN from "@/legal/privacy-policy.md?raw";
import LegalShell from "./_LegalShell";
import LegalMarkdown from "./_LegalMarkdown";
import { LEGAL_HASH, LEGAL_UPDATED } from "@/legal/version";

export default function Privacy() {
  return (
    <LegalShell
      title="Privacy Policy and Data Processing Addendum"
      updated={LEGAL_UPDATED}
      canonicalPath="/privacy"
    >
      <p
        style={{
          margin: "0 0 24px",
          fontFamily: "monospace",
          fontSize: 11,
          overflowWrap: "anywhere",
          color: "#766b5d",
        }}
      >
        SHA-256 {LEGAL_HASH}
      </p>
      <LegalMarkdown markdown={MARKDOWN} />
    </LegalShell>
  );
}
